import { gql } from '@apollo/client';

export const GET_MY_TEAMS = gql`
  query MyTeams {
    teams {
      id
      name
      organisationId
    }
  }
`;
